import i18n from "i18next";
import yaml from "js-yaml";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import resourcesToBackend from "i18next-resources-to-backend"; // Import the adapter

// --- Vite dynamic imports ---
// Path: /src/services/i18n.jsx
// Translations: /src/locales/{lng}/{ns}.yml
// Relative path from i18n.jsx to locales/ is '../locales/'
const translationMetaModules = import.meta.glob("../locales/*/*.yml", {
  query: "?raw", // The new way to specify raw import
  import: "default", // We want the default export, which for ?raw is the string content
  eager: false, // Default, but good to be explicit for dynamic imports
});

// Logging to verify Vite found your files and the paths are what you expect
console.log(
  "Vite translationMetaModules:",
  Object.keys(translationMetaModules)
);
// Example keys you should see if correct:
// '../../locales/en/about.yml'
// '../../locales/en/common.yml'
// etc.

// namespaces that will lazy load after initial load
// currently this routes on the game path so it is always fast
const definedNamespaces = ["instructions", "consent", "game", "card"];

// Add the namespaces you want to load by default
// currently those needed for the landing page
const initialNamespacesToLoad = ["common", "menubar", "landing"];

// --- Adapter function for resourcesToBackend ---
// This function will be called by i18next via resourcesToBackend
// It needs to return a Promise that resolves to the parsed resources object
const loadResources = async (language, namespace) => {
  const path = `../locales/${language}/${namespace}.yml`;

  if (translationMetaModules[path]) {
    try {
      const moduleImporter = translationMetaModules[path];
      const rawContent = await moduleImporter(); // Execute dynamic import, get raw YAML string
      const parsedResources = yaml.load(rawContent); // Parse YAML
      return parsedResources;
    } catch (error) {
      console.error(
        `resourcesToBackend: Error loading or parsing ${path}:`,
        error
      );
      throw error; // Propagate error so i18next knows loading failed
    }
  } else {
    console.warn(
      `resourcesToBackend: Translation module not found for path: ${path}`
    );
    // This means your glob pattern or file structure doesn't match
    throw new Error(`Module not found for ${language}/${namespace}`);
  }
};

i18n
  .use(resourcesToBackend(loadResources)) // Use the adapter
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ns: definedNamespaces,
    // Specify ONLY the namespaces to load by default/initially
    defaultNS: initialNamespacesToLoad,

    // THIS IS KEY FOR LAZY LOADING OTHER NAMESPACES
    partialBundledLanguages: true,
    fallbackLng: "en", // Default language if detection fails or detected lang not supported
    debug: import.meta.env.DEV, // Enable debug output in development
    supportedLngs: ["en"], // Add other languages as you create src/locales/{lang}/... files

    // react-i18next specific options
    react: {
      useSuspense: true, // Crucial for components to wait for translations
    },

    // Options for LanguageDetector (optional, defaults are often fine)
    // detection: {
    //   order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag'],
    //   caches: ['localStorage', 'cookie'],
    // },
  });

export default i18n;
